
const Attributes = {
    enableAddButton: false,
    enableSendButton: false,
    modes: [

    ],
};

export { Attributes };